import { useAuth } from '@/features/auth';

/**
 * Returns true while the onboarding tooltip pointers are active for the current user.
 * Mirrors the same localStorage key written by DocumentListPage on onboarding completion.
 */
export function useIsOnboardingActive(): boolean {
  const { user } = useAuth();
  const key = user?.id ? `onboarding_show_tooltips_${user.id}` : 'onboarding_show_tooltips';
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}
